import resourceList from '../resource_list';
import rest from '../rest';

async function callReferViaWeb(postData) {
  return rest.postAcl(resourceList.REWARD, '/customer/account/refer-by-merchant/add', postData);
}

export default callReferViaWeb;
